// import TabsView from '@/layouts/tabs/TabsView'
// import BlankView from '@/layouts/BlankView'
import PageView from '@/layouts/PageView'
import options from '@/router/async/config.async'

function renameProp(obj, propName, newPropName) {
	const val = obj[propName];
	if (typeof val !== "undefined" && val !== null) {
		obj[newPropName] = String(val);
		delete obj[propName];
	}
}

function convertMenuConfigNodeToRouteConfigNode(node) {

	if (node) {

		renameProp(node, "url", "path");
		renameProp(node, "title", "name");
		renameProp(node, "id", "router");
		renameProp(node, "pid", "parentRouter");
		//权限配置
		if (node.bussinessNo) {//有具体业务
			node.authority = {
				permission: node.bussinessNo,
			}
		}
		if (!node.icon) {
			// node.icon = "ant-design";
		}
		if (!node.path) {
			console.log('无path node',node)
			node.component = PageView;
		}
		// if (node.path) {
		// 	node.path = node.path + '?businessNo=' + node.bussinessNo;
		// }
	}
	if (node.children) {
		node.children.forEach(function (i) {
			convertMenuConfigNodeToRouteConfigNode(i);
		})
	}
}

/**
 * 固定菜单  qf39
 * @type {Array}
 */
const staticMenu = [
		{
	router: "workspace",
	path: "workspace",
	name: "首页",
	// meta: {
	// 	// 隐藏菜单，但是导航是生效的
	// 	// 官方文档的invisible无效 https://iczer.gitee.io/vue-antd-admin-docs/develop/router.html#%E8%B7%AF%E7%94%B1
	// 	menu: false
	// }
	},
];

const demoMenu = [
	// 移动到config.async.js
].concat(options.menuRoutesConfig)
		.map(item => {
			if (!item.meta) {
				item.meta = {};
			}
			item.meta.static = true;
			return item;
		});

/**
 * 将ebase的菜单格式转换为vue admin的格式
 * @param config
 * @return {{path: string, router: string, children: *[], name: string}[]}
 */
function convertMenuConfigToRouteConfig(config) {
	if (config && config.length) {
		config.forEach(function (configNode) {
			convertMenuConfigNodeToRouteConfigNode(configNode);
		})
	}

	/**
	 * 因为初始化导航的时候会从rootRoute(path=/)获取children作为菜单，所以要把后台返回的菜单加入一个rootRoute内
	 */
	return [{
		router: "root",
		path: "/",
		name: "首页",
		component: PageView,
		children: staticMenu.concat(config).concat(demoMenu)
	}];
}

export {
	convertMenuConfigToRouteConfig
};
